
import { useEffect, useState, useRef } from "react";

import { observer, inject } from "mobx-react";

import { useTranslation } from "react-i18next";
import { InnerBox, MobileBox, ScrollDiv } from "./Common";
import { Button, Text, TextInput } from "../UI";
import SendImg from "../assets/img/send.svg";
import UsrImg from "../assets/img/usr_icon.svg";
import ExpandImg from "../assets/img/expand_icon.svg";
import CollpseImg from "../assets/img/collapse_icon.svg";

import { useInput } from "../utils/hooks";
import { isNotEmpty, withError } from "../validation";
import DOMPurify from "dompurify";

import { useTheme } from "styled-components";
import { format } from "date-fns";
import { useMobile } from "../utils/mobile";
import MobileHeader from "../layouts/MobileHeader";
import { Role } from "../stores/userStore";




const Message = ({ message, handleUpdateMessageClick }) => {
    const theme = useTheme();
    const { t } = useTranslation("applies");



    return (
        <div style={{ marginBottom: 10 }}>
            <div
                key={message?.index}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems:
                        message?.ISTENANT === "Y"
                            ? "flex-end"
                            : "flex-start",
                }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: message?.ISTENANT === "Y" ? "row-reverse" : "row",
                        alignItems: "center",
                        justifyContent:
                            message.ISTENANT === "Y"
                                ? "flex-end"
                                : "flex-start",
                        gap: 10,
                    }}
                >
                    <div style={{
                        backgroundColor: theme.color.gray30,
                        borderRadius: 50,
                        width: 30,
                        height: 30,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                    }}>
                        <img
                            src={UsrImg}
                            alt="usr"
                        />
                    </div>


                    <Text
                        size={14}
                        weight={400}>
                        {message.NAME}
                    </Text>

                </div>

                <div
                    style={{
                        backgroundColor: message?.ISTENANT === "Y" ?
                            theme.color.primary : theme.color.gray30,
                        borderRadius: message?.ISTENANT === "Y" ? "0px 8px 8px 8px" : "8px 0px 8px 8px",
                        gap: 4,
                        display: "inline-flex",
                        padding: "8px 12px",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 4,
                        width: "fit-content",
                        flexDirection: "column",
                    }}>
                    <div
                        style={{
                            width: "fit-content",
                            fontSize: 14,
                            color: message?.ISTENANT === "Y" ? theme.color.white : theme.color.textSecondary,
                            lineHeight: 1.6,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(message?.ZCOB_TENANTCONVTEXT_SUBFORM?.TEXT || ''),
                        }}></div>

                    {message?.VISITCOORDINATE === "Y" &&

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 16,
                            }}
                        >
                            <Button
                                style={{
                                    width: 140,
                                    marginTop: 0,
                                }}

                            >
                                <div
                                    onClick={() => { handleUpdateMessageClick(message, true) }}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >

                                    {message?.VISITAPPROVED === "Y" ? t("visit_approved") : t("approve_visit")}
                                </div>
                            </Button>
                            <Button
                                onClick={() => { handleUpdateMessageClick(message, false) }

                                }
                                style={{
                                    width: 110,
                                    backgroundColor: theme.color.white,
                                    border: `1px solid ${theme.color.primary}`,
                                    color: theme.color.primary,
                                    marginTop: 0,
                                }}
                            >
                                {message?.VISITCANCEL === "Y" ? t("visit_canceled") : t("cancel_visit")}
                            </Button>
                        </div>
                    }

                    <Text
                        size={11}
                        weight={400}
                        color={message?.ISTENANT === "Y" ? theme.color.white : theme.color.textSecondary}
                        style={{
                            alignSelf: "flex-end",
                            marginTop: 4,
                        }}
                    >
                        {format(new Date(message?.COMDATE), "dd/MM/yyyy HH:mm")}
                    </Text>

                </div>

            </div>

        </div >
    )
}

const RepairMessages = ({ repairPage, messages, userStore, repairPagesStore, tenantsStore }) => {

    const { t } = useTranslation("applies");

    const inputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const theme = useTheme();

    const isMobile = useMobile();


    const [expandedMessages, setExpandedMessages] = useState(false);

    const [messagesList, setMessagesList] = useState(messages || repairPagesStore.selectedRepairPage?.ZCOB_TENANTCONV_SUBFORM || []);
    const [messageText, setMessageText] = useState("");


    useEffect(() => {

        const markAllAsRead = async () => {
            await repairPagesStore.updateMessagesAsRead({
                CUST: userStore.userDetails.CUST,
                DNAME: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
                ENV: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
                REPAIRNAME: repairPage?.REPAIRNAME || repairPagesStore.selectedRepairPage?.REPAIRNAME,
                SPACENAME: repairPage?.SPACENAME || repairPagesStore.selectedRepairPage?.SPACENAME,
                KLINES: messagesList?.filter(m => m.ISNEW === "Y" && m.ISTENANT !== "Y")?.map(m => m.KLINE) || []

            });
        };

        markAllAsRead();
        setMessagesList(messages || repairPagesStore.selectedRepairPage?.ZCOB_TENANTCONV_SUBFORM || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "end",
        });
    }, [messagesList]);





    const isNotEmptyWithError = withError(
        isNotEmpty,
        t("text_field_empty_error")
    );


    const messageTextInput = useInput({
        validation: [isNotEmptyWithError],
        placeholder: t("message_input_placeholder"),
        onChange: (e) => setMessageText(e.target.value),
        value: messageText || "",
    });

    const handleAddMessageClick = async () => {
        inputRef.current?.focus();
        const updatedMessages = await repairPagesStore.addConversationMessage({
            CUST: userStore.userDetails.CUST,
            DNAME: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
            ENV: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
            REPAIRNAME: repairPage?.REPAIRNAME || repairPagesStore.selectedRepairPage?.REPAIRNAME,
            SPACENAME: repairPage?.SPACENAME || repairPagesStore.selectedRepairPage?.SPACENAME,

            data: {
                ZCOB_TENANTCONVTEXT_SUBFORM: {
                    TEXT: messageTextInput.value,
                },
                ISTENANT: "Y",
                COMDATE: new Date(),
                NAME: userStore.userDetails.NAME
            }
        });

        setMessagesList(updatedMessages);
        setMessageText("");

    };


    const handleUpdateMessageClick = async (message, approve) => {
        inputRef.current?.focus();
        const updatedMessages = await repairPagesStore.updateConversationMessage({
            CUST: userStore.userDetails.CUST,
            DNAME: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
            ENV: tenantsStore.selectedContract?.DNAME || tenantsStore.selectedSiteSpace?.DNAME,
            REPAIRNAME: repairPage?.REPAIRNAME || repairPagesStore.selectedRepairPage?.REPAIRNAME,
            SPACENAME: repairPage?.SPACENAME || repairPagesStore.selectedRepairPage?.SPACENAME,
            KLINE: message.KLINE,
            REPAIR: repairPage?.REPAIR || repairPagesStore.selectedRepairPage?.REPAIR,


            data: {
                VISITAPPROVED: approve === true ? "Y" : "",
                VISITCANCEL: approve === false ? "Y" : "",
                ISNEW: "N"
            }
        });

        setMessagesList(updatedMessages);
        setMessageText("");

    };

    const expandModal = (expand) => {
        setExpandedMessages(expand);
    };

    return (
        <>
            {!isMobile ?
                <div style={{
                    width: expandedMessages ? "50vw" : "33vw", height: expandedMessages ? "95vh" : "80vh",
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: 20,
                        borderStartStartRadius: 18,
                        borderStartEndRadius: 18,

                        backgroundColor: theme.color.primary,
                    }}>
                        <Text weight={500} size={15} color={theme.color.white} style={{ padding: 4, textAlign: "start" }}>
                            {`${t("messages")} /
              ${t("inquiry_number", {
                                num: repairPage?.REPAIRNAME || repairPagesStore.selectedRepairPage?.REPAIRNAME,
                            })}`}


                        </Text>
                        <div onClick={() => expandModal(!expandedMessages)}
                        >
                            <img
                                src={expandedMessages ? CollpseImg : ExpandImg}
                                alt="Expand"
                            />

                        </div>
                    </div>
                    <ScrollDiv style={{ flex: 1, minHeight: expandedMessages ? "80vh" : "65vh", padding: 20 }}>
                        {messagesList?.map((msg, index) => (

                            <Message
                                key={index}
                                message={msg}
                                handleUpdateMessageClick={handleUpdateMessageClick}
                            />
                        ))}
                        <div ref={messagesEndRef} />
                    </ScrollDiv>
                    <div style={{ width: "100%", paddingInline: 20 }}>
                        <TextInput
                            refProp={inputRef}
                            style={{
                                display: "flex",
                                padding: 4,

                                justifyContent: "center",
                                alignItems: "center",

                                width: expandedMessages ? "50vw" : "33vw",


                            }}
                            {...messageTextInput}

                            variant="outlined"
                            startImgStyle={{ width: 30, height: 30 }}
                            startImg={SendImg}
                            onStartImgClick={handleAddMessageClick}
                            onKeyDown={(e) => {

                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleAddMessageClick();
                                }
                            }}


                        ></TextInput>
                    </div>


                </div> : <div style={{ display: "flex", margin: 0, flexDirection: "column", flex: 1 }}>
                    <MobileHeader
                        name={userStore.userDetails.NAME}
                        navigateTo={"messages"}
                        admin={userStore.userDetails.role === Role.Admin}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <MobileBox
                            flexBasis={70}
                            style={{ height: "100vh", width: "100%", borderRadius: 0 }}
                        >
                            <InnerBox isMobile={true} style={{ padding: 0 }}>
                                <div style={{
                                    padding: 20,
                                    display: "flex", justifyContent: "center", alignItems: "center"
                                }} >
                                    <Text.BM >
                                        {t("applies:new_repair_messages",
                                            {
                                                num: messagesList?.filter(m => m.ISNEW === "Y")?.length
                                            }
                                        )}
                                    </Text.BM>
                                </div>
                                <ScrollDiv style={{ minHeight: "80vh", padding: 20 }} >
                                    {messagesList?.map((msg, index) => (

                                        <Message
                                            key={index}
                                            message={msg}
                                            handleUpdateMessageClick={handleUpdateMessageClick}
                                        />
                                    ))}
                                    <div ref={messagesEndRef} />
                                </ScrollDiv>
                                <div style={{ width: "100%", paddingInline: 20 }}>
                                    <TextInput
                                        refProp={inputRef}
                                        style={{
                                            display: "flex",
                                            padding: 4,

                                            justifyContent: "center",
                                            alignItems: "center",

                                            width: expandedMessages ? "50vw" : "33vw",


                                        }}
                                        {...messageTextInput}

                                        variant="outlined"
                                        startImgStyle={{ width: 30, height: 30 }}
                                        startImg={SendImg}
                                        onStartImgClick={handleAddMessageClick}
                                        onKeyDown={(e) => {

                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleAddMessageClick();
                                            }
                                        }}

                                    ></TextInput>
                                </div>
                            </InnerBox>
                        </MobileBox>
                    </div>


                </div>}

        </>





    );
};
export default inject(
    "userStore",
    "tenantsStore",
    "repairPagesStore"
)(observer(RepairMessages));

